class AdventCountdownPromos extends window.PURELEI.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.togglePromos.bind(this),
    )
  }

  togglePromos () {
    const isVisible =
      this.els.container.element.getAttribute('aria-hidden') !== 'true'
    const buttonText =
      this.els.trigger.element.dataset[isVisible ? 'text' : 'textAlt']

    this.els.container.element.setAttribute('aria-hidden', isVisible)
    this.els.trigger.element.querySelector('.btn-Button_Text').innerText =
      buttonText
  }
}

if (!customElements.get('advent-countdown-promos')) {
  customElements.define('advent-countdown-promos', AdventCountdownPromos)
}
